const getStaticBase = () => {
    return String(typeof __APP_STATIC_BASE__ !== 'undefined' ? __APP_STATIC_BASE__ : '/static').replace(/\/$/, '')
}

const toStaticAsset = (inputPath = '') => {
    const base = getStaticBase()
    let path = String(inputPath || '').trim()

    if (!path)
        return base

    if (/^(data:|blob:|https?:|\/\/)/i.test(path))
        return path

    if (path.startsWith(base)) {
        path = path.slice(base.length)
    }

    const normalized = path
        .replace(/^\.\//, '')
        .replace(/^(\.\.\/)+static\//, '')
        .replace(/^static\//, '')
        .replace(/^\/?static\//, '')
        .replace(/^\/?staging\//, '')

    const withLeadingSlash = normalized.startsWith('/') ? normalized : `/${normalized}`

    return `${base}${withLeadingSlash}`
}
export { getStaticBase, toStaticAsset }
export default toStaticAsset
